export enum DrivingRequestLocationEvidenceKindEnum {
  ORIGIN = 'origin',
  DESTINATION = 'destination',
  WORKING_TIME = 'working_time',
  CLOCK_REGISTER = 'clock_register',
}
